import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";

import LangSwitcher from "../../Components/LangSwitcher";
import MainHeader from "../../Components/MainHeader/MainHeader";
import CustomButton from "../../Components/CustomButton";
import GoogleLoginBtn from "../../Components/GoogleLoginBtn";
import FacebookLoginBtn from "../../Components/FacebookLoginBtn";

import "./style.scss";

const InvitedSignUpLink = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const queryParams = Object.fromEntries([...params]);

  useEffect(() => {
    localStorage.removeItem("ps10005000");
    localStorage.removeItem("ps10004000");
  }, []);

  return (
    <div className="main-container">
      <MainHeader />

      <div className="invited-signup-link-header">
        <h2>
          {t("invited_create_account_header", {
            coach: queryParams.name,
            activity: queryParams.activity,
          })}
        </h2>
        <p>{t("invited_create_account_subheader")}</p>
      </div>

      <div className="sso-section">
        <FacebookLoginBtn />
        <GoogleLoginBtn />
      </div>

      <div className="login-sections-devider">
        <div id="login-sections-devider-left"></div>
        <span>or</span>
        <div id="login-sections-devider-right"></div>
      </div>

      <div className="invited-signup-link-button">
        <CustomButton
          fullWidth
          fontSize="1.2rem"
          onClick={() => {
            navigate(`/role-selector/consumer-registration${location.search}`);
          }}
        >
          {t("sign_up")}
        </CustomButton>
      </div>

      <LangSwitcher />
    </div>
  );
};

export default InvitedSignUpLink;
